import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SyncableAction, SyncState } from './types';

const initialState: SyncState = {};

type QueueActionPayload = {
  action: Omit<SyncableAction, "timestamp">,
  accountID: string
}

const syncSlice = createSlice({
  name: 'sync',
  initialState,
  reducers: {
    clearQueue: (state, action: PayloadAction<string>) => {
      state[action.payload].queue = [];
    },
    forceSync: () => {},
    queue: (state, action: PayloadAction<QueueActionPayload>) => {
      if (!state[action.payload.accountID]) {
        state[action.payload.accountID] = { queue: [] };
      }
      state[action.payload.accountID].queue.push({
        ...action.payload.action,
        meta: {
          account: action.payload.accountID,
          timestamp: Date.now()
        }
      });
    },
    setLastAttempt: (state, action: PayloadAction<string>) => {
      if (!state[action.payload]) {
        state[action.payload] = { queue: [] };
      }
      state[action.payload].lastAttempt = Date.now();
    },
    setLastSuccess: (state, action: PayloadAction<string>) => {
      if (!state[action.payload]) {
        state[action.payload] = { queue: [] };
      }
      state[action.payload].lastSuccess = Date.now();
    }
  }
});

export const syncActions = syncSlice.actions;

export default syncSlice.reducer;
